module.exports = __webpack_public_path__ + "img/did-you-know.41e247ad.png";